import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { useFlagsService } from '@atlassian/jira-flags';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { createFormatMessage } from '@atlassian/jira-servicedesk-common/src/i18n/format-message/index.tsx';
import { getPageOnDelete } from '@atlassian/jira-servicedesk-knowledge-common/src/common/utils.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { deleteTopic as deleteTopicService } from '@atlassian/jira-servicedesk-knowledge-common/src/services/delete-topic/index.tsx';
import { TOPICS_PAGE_SIZE, PACKAGE_NAME, TEAM_NAME } from '../../../../common/constants.tsx';
import type { Props, State } from '../../types.tsx';
import { removeTopic } from '../../utils.tsx';
import messages from './messages.tsx';

export const dismissTopic =
	(topicId: string) =>
	async ({ getState, setState }: StoreActionApi<State>, props: Props): Promise<void> => {
		const { projectId, createAnalyticsEvent, locale, activationId } = props;
		const currentTopics = getState().topics.data;
		// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
		const { showFlag } = useFlagsService();
		const formatMessage = createFormatMessage(locale);

		try {
			setState({
				...getState(),
				topics: {
					...getState().topics,
					loading: true,
					error: null,
				},
			});
			projectId && (await deleteTopicService(projectId, topicId, activationId));
			const updatedTopics = removeTopic(currentTopics, topicId);
			const page = getPageOnDelete(getState().page, updatedTopics.length, TOPICS_PAGE_SIZE);
			setState({
				...getState(),
				topics: {
					data: updatedTopics,
					loading: false,
					error: null,
				},
				page,
			});
			showFlag({
				type: 'success',
				title: formatMessage(messages.dismissTopicSuccessTitle),
				isAutoDismiss: true,
				messageId:
					'servicedesk-knowledge-performance.controllers.store.actions.dismiss-topic.show-flag.success',
				messageType: 'transactional',
			});
			fireTrackAnalytics(createAnalyticsEvent({}), 'dismissTopic succeeded');
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...getState(),
				topics: {
					...getState().topics,
					loading: false,
					error,
				},
			});
			showFlag({
				type: 'error',
				title: formatMessage(messages.dismissTopicErrorTitle),
				description: formatMessage(messages.dismissTopicErrorDescription),
				isAutoDismiss: true,
				messageId:
					'servicedesk-knowledge-performance.controllers.store.actions.dismiss-topic.show-flag.error',
				messageType: 'transactional',
			});
			fireErrorAnalytics({
				meta: {
					id: 'dismissTopic',
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				error,
			});
		}
	};
